import React from 'react';
import ReactEcharts from 'echarts-for-react';
import { isAdmin } from 'utils/isAdmin';

export const HorizontalBarChartNOC = ({
  text = 'Fluid Flow',
  height = '200px',
  width = '400px',
  label = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'],
  data = [],
  unit = 'm³/s',
}) => {
  const isAdminRoute = isAdmin() ? '#000' : '#fefefe';

  const options = {
    title: {
      text: text, // Tiêu đề biểu đồ
      left: 'center',
      textStyle: {
        fontSize: 20,
        fontWeight: 'bold',
        color: '#5470c6',
      },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
    },
    grid: {
      left: '10%',
      right: '15%',
      top: '15%',
      bottom: '10%',
      containLabel: true,
    },
    xAxis: {
      type: 'value',
      name: unit,
      nameLocation: 'end',
      nameTextStyle: {
        fontSize: 12,
        padding: [0, 0, 0, -10],
      },
      axisLine: {
        lineStyle: {
          color: isAdminRoute,
        },
      },
      axisLabel: {
        fontSize: 12,
        color: isAdminRoute,
      },
    },
    yAxis: {
      type: 'category',
      data: label, // Tên các hạng mục
      axisLine: {
        lineStyle: {
          color: isAdminRoute,
        },
      },
      axisLabel: {
        fontSize: 12,
      },
    },
    series: [
      {
        type: 'bar',
        data: data, // Dữ liệu
        barWidth: '50%', // Độ rộng của thanh
        itemStyle: {
          color: '#29B6F6', // Màu thanh
        },
        label: {
          show: true,
          position: 'right', // Hiển thị giá trị bên phải
          formatter: '{c}',
          fontSize: 12,
          color: isAdminRoute,
        },
      },
    ],
  };
  return (
    <ReactEcharts
      option={options}
      style={{ width: width, height: height }}
      onEvents={() => {}}
    />
  );
};
